module.exports = __webpack_public_path__ + "img/circle_outline.d6f98855.svg";